import(/* webpackMode: "eager", webpackExports: ["HabitsView"] */ "/vercel/path0/ui/components/app/HabitsView.tsx");
